/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type infoChangeContainerStageInput = {
    clientMutationId?: string | null;
    slug: string;
    stage: string;
};
export type ContainerPickSentStageChangeMutationVariables = {
    input: infoChangeContainerStageInput;
};
export type ContainerPickSentStageChangeMutationResponse = {
    readonly infoChangeContainerStage: {
        readonly clientMutationId: string | null;
    } | null;
};
export type ContainerPickSentStageChangeMutation = {
    readonly response: ContainerPickSentStageChangeMutationResponse;
    readonly variables: ContainerPickSentStageChangeMutationVariables;
};



/*
mutation ContainerPickSentStageChangeMutation(
  $input: infoChangeContainerStageInput!
) {
  infoChangeContainerStage(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "infoChangeContainerStagePayload",
    "kind": "LinkedField",
    "name": "infoChangeContainerStage",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ContainerPickSentStageChangeMutation",
    "selections": (v1/*: any*/),
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ContainerPickSentStageChangeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "16d6a0530b0b2b0343e78676eeeecf38",
    "id": null,
    "metadata": {},
    "name": "ContainerPickSentStageChangeMutation",
    "operationKind": "mutation",
    "text": "mutation ContainerPickSentStageChangeMutation(\n  $input: infoChangeContainerStageInput!\n) {\n  infoChangeContainerStage(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = 'd06651c511a561c23fbaacf34301632f';
export default node;
